import React from 'react'
import { Footer } from "flowbite-react";

const FooterArea = () => {
  return (
    <Footer className="fixed w-full text-center border-t border-grey p-4 bottom-0 shadow-md">
      <Footer.Copyright href="#" by="Portal operaciones - Exxis™" year={2025} className='w-full text-center'/>
    </Footer>
  )
}

export default FooterArea
